import {
    UPDATE_LOGIN_STATUS,
    CHECK_LOGIN_STATUS,
    LOGOUT,
    FETCH_USER_DATA,
    CLEAR_ERROR_MSG
} from '../ActionTypes'

const INITIAL_STATE = {
    isLogin: null,
    token: localStorage.getItem('token') || '',
    userName: '',
    userId: '',
    userType: '',
    errMsg: ''
}

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case CLEAR_ERROR_MSG:
            return {...state, errMsg: '' }
        case UPDATE_LOGIN_STATUS:
            if (action.payload.success) {
                localStorage.setItem('token', action.payload.token)
                return {...state,
                    isLogin: true,
                    token: action.payload.token
                }
            } else if (status === 'processing') {
                return {...state,
                    isLogin: 'processing'
                }
            } else {
                return {...state,
                    isLogin: false,
                    errMsg: 'Invalid Username/Password.'
                }
            }
        case CHECK_LOGIN_STATUS:
            return {...state,
                isLogin: action.payload.success
            }
        case LOGOUT:
            return { INITIAL_STATE }
        case FETCH_USER_DATA:
            return {...state,
                userId: action.payload.user_id,
                userName: action.payload.first_name,
                userType: action.payload.user_type,
            }
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/App/AuthReducer.js